import { useTranslation } from "react-i18next";

import { NotFoundComponent } from "../NotFound/components/NotFoundComponent";

export const QrCodePage = () => {
    const { t } = useTranslation();

    return (
        <NotFoundComponent>
            <h1 className=" text-lg font-bold text-slate-800">{t("qrCodeAlert")}!</h1>
        </NotFoundComponent>
    );
};
